<app-command [command]="persist$" (success)="saved()">
  <modal (close)="cancel()" class="contacts-reassign-modal">
    <modal-header>
      <h2>{{ determineModalTitle }}</h2>
    </modal-header>
    <modal-content>
      <div class="reassign">
        <ng-container [ngSwitch]="displayState">
          <!-- step 1 / select -->
          <ng-container *ngSwitchCase="DisplayState.Selection">
            <ng-container *ngTemplateOutlet="tplSelection"></ng-container>
          </ng-container>

          <!-- step 2 / confirm -->
          <ng-container *ngSwitchCase="DisplayState.Confirmation">
            <ng-container *ngTemplateOutlet="tplConfirmation"></ng-container>
          </ng-container>
        </ng-container>
      </div>
    </modal-content>
    <modal-footer>
      <lds-button appearance="default" (click)="onClickSecondaryAction()">
        {{ determineSecondaryBtnLabel }}
      </lds-button>

      <lds-button
        appearance="action"
        [isDisabled]="determinePrimaryBtnState"
        (click)="onClickPrimaryAction()">
        {{ determinePrimaryBtnLabel }}
      </lds-button>
    </modal-footer>
  </modal>
</app-command>

<!-- templates -->

<!-- tpl / selection -->
<ng-template #tplSelection>
  <div *appLoad="let data of initialise$">
    <div class="contacts__reassignment__filter mb-3" [formGroup]="filterForm">
      <spark-contact-filters
        identifier="contact-reassign"
        formControlName="filter"
        (sortOptionChanged)="onSortSelected($event)"
        [defaultFilter]="defaultFilterOptions"
        [users]="data.assignableUsers">
      </spark-contact-filters>
    </div>


    <form [formGroup]="form">
      <div class="reassignment">
        <div class="row">
          <div class="col-12 col-sm col-lg-5">
            <h4>Individuals</h4>
            <app-user-dropdown
              [users]="data.assignableUsers"
              [placeholder]="'please select'"
              [includeAllOption]="false"
              [label]="'Reassign contacts to'"
              formControlName="reassignTo">
            </app-user-dropdown>
          </div>
        </div>
      </div>

      <div class="contacts">
        <div class="d-flex justify-content-between">
          <h4>Contacts</h4>        
          <lds-toggle
            identifier="select_all"
            name="select_all"
            [isChecked]="false"
            (getChange)="toggleAllContacts($event)">
          </lds-toggle>
        </div>

        <!-- no results -->
        <ng-container *ngIf="!data.contacts.length; else tplHasResults">
          <lds-inline-message
            appearance="info"
            message="Sorry, we could not find any related contacts for reassignment.">
          </lds-inline-message>
        </ng-container>

        <!-- has results -->
        <ng-template #tplHasResults>
          <div
            class="contact"
            *ngFor="let contact of data.contacts | sortBy : selectedSortOption">
            <div
              class="row align-items-center align-items-sm-start align-items-lg-center">
              <div class="col col-lg">
                <div class="contact__name">{{ contact.name }}</div>
                <div class="reassignment__helper">
                  {{ contact.portfolio | adviserName : assignableUsers }}
                </div>
              </div>
              <div class="col-auto order-lg-last mt-sm-2 col-lg-auto mt-lg-0">
                <lds-toggle
                  [identifier]="contact.id"
                  [name]="contact.id"
                  [isChecked]="isContactSelected(contact)"
                  (getChange)="onToggleContact($event, contact)">
                </lds-toggle>
              </div>
              <div class="col-12 mt-2 col-lg mt-lg-0">
                <div class="row">
                  <div class="col-6">
                    <div class="contact__label">Type</div>
                    <div class="contact__text">
                      {{ contact.contactType }}
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="contact__label">Entity</div>
                    <div class="contact__text">
                      {{ contact.entityType }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </div>
    </form>
  </div>
</ng-template>

<!-- tpl / confirmation -->
<ng-template #tplConfirmation>
  <p class="info">
    Please review the selected contacts (<strong>{{
      this.selectedList.length
    }}</strong
    >) for reassignment. Upon confirming these will be reassigned to
    <strong>{{ reassignTo.value | adviserName : assignableUsers }}</strong
    >.
  </p>

  <div class="contacts">
    <div class="contact" *ngFor="let contact of selectedList">
      <div
        class="row align-items-center align-items-sm-start align-items-lg-center">
        <div class="col col-lg">
          <div class="contact__name">{{ contact.name }}</div>
        </div>
        <div class="col-12 mt-2 col-lg mt-lg-0">
          <div class="row">
            <div class="col-6">
              <div class="contact__label">Type</div>
              <div class="contact__text">
                {{ contact.contactType }}
              </div>
            </div>
            <div class="col-6">
              <div class="contact__label">Entity</div>
              <div class="contact__text">{{ contact.entityType }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
